import { registerSuperJson } from "@grafit/shared-api-router/register";
import type { TrpcRouter } from "@grafit/shared-api-router/trpc-router";
import { httpBatchLink, httpSubscriptionLink, splitLink, TRPCClientError } from "@trpc/client";
import { createTRPCReact } from "@trpc/react-query";

registerSuperJson();

export const trpc = createTRPCReact<TrpcRouter>();
export { httpBatchLink, httpSubscriptionLink, splitLink, TRPCClientError };
